<template>
	<article class="d-subject-list-custom">
		<PageHero v-bind="{ ...header, breadcrumb }" />
		<div
			class="
				grid
				gap-x-xl gap-y-sm
				>=768:gap-y-md
				grid-cols
				>=768:grid-cols-2
				>=1024:grid-cols-3
				my-84
				>=1024:my-104
				mx-layout-margin
			"
		>
			<div v-for="(item, index) in items" :key="index">
				<NuxtLinkExt :to="item.url">
					<div class="flex items-center w-full group transform pr-8">
						<div class="flex-shrink-0">
							<PageIcon
								:name="item.icon"
								class="text-text mr-sm h-24 w-24"
							/>
						</div>
						<div
							class="
								duration-500
								ease-smooth-out
								transform
								group-hover:translate-x-8
							"
						>
							<h3
								class="text-h3 font-semibold"
								v-text="item.title"
							></h3>

							<!-- todo: Apparently removed, checkup with Sonni -->
							<!-- <p
								class="hidden >=768:block mt-10"
								v-text="item.teaser"
							></p> -->
						</div>
					</div>
				</NuxtLinkExt>
			</div>
		</div>
		<!-- Call to action box -->
		<div v-if="callToActionBox" class="px-layout-margin bg-secondary">
			<div
				:class="[
					'flex flex-col justify-center items-center space-y-sm',
					'>=768:flex-row >=768:space-x-layout-gutter >=768:space-y-0',
					{ 'py-lg': callToActionBox.content.image },
					{ 'py-xl': !callToActionBox.content.image },
				]"
			>
				<!-- Image -->
				<div v-if="callToActionBox.content.image" class="flex-1 w-6col">
					<UmbracoImageExt
						:alt="callToActionBox.content.image.altText"
						:source-url="
							callToActionBox.content.image.cropUrl ||
							callToActionBox.content.image.url
						"
						:source-width="callToActionBox.content.image.width"
						:source-height="callToActionBox.content.image.height"
						:widths="[
							320,
							417,
							768,
							1024,
							1920,
							1024 * 2,
							1920 * 2,
						]"
						:aspect-ratio="8 / 5"
						class="w-full rounded-md overflow-hidden"
					/>
				</div>

				<!-- Content -->
				<div
					:class="[
						'flex flex-col justify-center w-6col >=768:px-1col',
						{
							'items-center text-center':
								!callToActionBox.content.image,
						},
					]"
				>
					<div
						:class="{ 'max-w-488': callToActionBox.content.image }"
					>
						<BaseH1
							v-if="callToActionBox.content.title"
							tag="h2"
							class="mb-sm"
							v-text="callToActionBox.content.title"
						/>

						<!--
						<p
							v-if="callToActionBox.content.teaser"
							class="mb-md"
							v-text="callToActionBox.content.teaser"
						></p>
						-->

						<NuxtLinkExt
							v-if="callToActionBox.content.link[0]"
							:class="[
								'block w-fit',
								{ 'mx-auto': !callToActionBox.content.image },
							]"
							:to="callToActionBox.content.link[0].url"
							:target="callToActionBox.content.link[0].target"
						>
							<BaseButton class="w-fit" tag="div">
								<template #default>
									{{
										callToActionBox.content.linktext ||
										callToActionBox.content.link[0].name
									}}
								</template>

								<template #icon>
									<SvgArrow
										v-if="
											callToActionBox.content.link[0]
												.type === 'url'
										"
										class="transform -rotate-45"
									/>
								</template>
							</BaseButton>
						</NuxtLinkExt>
					</div>
				</div>
			</div>
		</div>

		<FeedbackForm v-if="activateFeedback" class="mb-lg" />
	</article>
</template>

<script>
import UmbracoImageExt from '~/components/shared/UmbracoImageExt';
import SvgArrow from '~/assets/svgs/arrow-icon.svg?inline';
import PageHero from '~/components/main/PageHero';
import PageIcon from '~/components/shared/PageIcon.vue';
import FeedbackForm from '~/components/shared/FeedbackForm';

export default {
	name: 'MainSubjectListCustom',

	components: {
		PageHero,
		UmbracoImageExt,
		SvgArrow,
		PageIcon,
		FeedbackForm,
	},

	inheritAttrs: false,

	props: {
		title: String,
		contentElements: Array,
		breadcrumb: Array,
		header: Object,
		callToActionBox: Object,
		items: Array,

		activateFeedback: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
